// This file is auto-generated by dibs-icons script
import { FC } from 'react';

type CheckCircle24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const CheckCircle24: FC<CheckCircle24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M17.085 9.795 10.74 16.14l-3.825-3.825 1.26-1.26 2.565 2.565 5.085-5.085 1.26 1.26Z" />
            <path
                d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-2 0a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default CheckCircle24;
